<div class="relative min-h-[600px]">
  <!-- Close Button (top-right) -->
  <div class="relative">
    <!-- Title -->
    <span mat-dialog-title class="block w-fit max-w-[calc(100%-48px)] text-center text-3xl font-bold">
      Szöveg módosítása
    </span>
    <button
      mat-icon-button
      mat-dialog-close
      color="primary"
      class="absolute top-0 right-0 scale-125"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Loading spinner -->
  <div
    *ngIf="loading"
    class="absolute -inset-10 z-10 flex items-center justify-center bg-white"
  >
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <!-- Scrollable Content Container -->
  <div class="dialog-content" *ngIf="!loading">
    <!-- Form Content -->
    <form [formGroup]="editForm" class="px-4">
      <!-- Current Values Section (Two Columns) -->
      <div class="mb-6 flex flex-col gap-x-6 md:flex-row">
        <!-- Hungarian Current Value -->
        <div class="grow basis-0">
          <p class="mb-2 text-sm font-medium">Aktuális magyar szöveg</p>

          <div
            class="mb-3 h-[290px] overflow-y-auto rounded-lg border-2 border-dashed border-customGray-100 bg-white p-4"
          >
            <p class="break-words text-sm">
              {{ copyData?.placeHolderInHungarian }}
            </p>
          </div>
          <div class="flex items-center justify-end">
            <button
              type="button"
              mat-stroked-button
              color="primary"
              (click)="copyToClipboard(copyData?.placeHolderInHungarian || '')"
              class="border-none text-dark-green"
            >
              <span class="text-sm font-bold">Vágólapra másol</span>
              <mat-icon class="ml-2">content_copy</mat-icon>
            </button>
          </div>
          <div class="flex">
            <mat-form-field appearance="standard" class="grow basis-0">
              <mat-label>Új magyar szöveg</mat-label>
              <textarea
                matInput
                formControlName="newHungarian"
                rows="5"
              ></textarea>
              <mat-error *ngIf="editForm.get('newHungarian')?.hasError('required')">Ez a mező kötelező</mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- English Current Value -->
        <div class="grow basis-0">
          <p class="mb-2 text-sm font-medium">Aktuális angol szöveg</p>

          <div
            class="mb-3 h-[290px] overflow-y-auto rounded-lg border-2 border-dashed border-customGray-100 bg-white p-4"
          >
            <p class="break-words text-sm">
              {{ copyData?.placeHolderInEnglish }}
            </p>
          </div>
          <div class="flex items-center justify-end">
            <button
              type="button"
              mat-stroked-button
              color="primary"
              (click)="copyToClipboard(copyData?.placeHolderInEnglish || '')"
              class="border-none text-dark-green"
            >
              <span class="text-sm font-bold">Vágólapra másol</span>
              <mat-icon class="ml-2">content_copy</mat-icon>
            </button>
          </div>
          <div class="flex">
            <mat-form-field appearance="standard" class="grow basis-0">
              <mat-label>Új angol szöveg</mat-label>
              <textarea matInput formControlName="newEnglish" rows="5"></textarea>
              <mat-error *ngIf="editForm.get('newEnglish')?.hasError('required')">Ez a mező kötelező</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Action Buttons -->
  <div
    *ngIf="!loading"
    mat-dialog-actions
    class="mb-0 mt-8 flex flex-col justify-end gap-4 border-t border-light-gray pt-6 md:flex-row md:border-none md:pt-0"
  >
    <button
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
      class="mol-btn-stroked-primary md:mol-btn-lg h-12 w-full rounded-2xl text-base font-bold md:h-16 md:max-w-[300px]"
    >
      Mégsem
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="onSave()"
      [disabled]="editForm.invalid"
      class="md:mol-btn-lg ml-0 h-12 w-full rounded-2xl text-base font-bold md:h-16 md:max-w-[300px]"
    >
      Módosítás
    </button>
  </div>
</div>
